var _defs, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFacebook(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 11.84,
    height: 21.53,
    viewBox: "0 0 11.84 21.53",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\r\n      .cls-1 {\r\n        fill: #f6961d;\r\n        fill-rule: evenodd;\r\n      }\r\n    "))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "facebook.svg",
    className: "cls-1",
    d: "M1259.8,8944.17h1.75v-3.43a21.47,21.47,0,0,0-3.11-.27c-3.16,0-5.23,1.93-5.23,5.42v3.06h-3.52v4.03h3.52v9.03h4.33v-9.03h3.23l0.61-4.03h-3.84v-2.61A2.007,2.007,0,0,1,1259.8,8944.17Z",
    transform: "translate(-1249.69 -8940.47)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebook);
export default __webpack_public_path__ + "static/media/facebook.e602aac2290a6058647dc21b516f1a0b.svg";
export { ForwardRef as ReactComponent };